import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "primary text-xl inline-block cursor-pointer select-none",
    onClick: _cache[0] || (_cache[0] = (e) => _ctx.openPopover( e, 'sortby', { items: _ctx.sortTerms, preselectedItem: _ctx.sortTerm }, (res) => _ctx.$emit('update:sortTerm', res)))
  }, " Sortierung: " + _toDisplayString(_ctx.sortTerm && _ctx.sortTerm.label), 1))
}